import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
const locale = 'en'

const i18n = new VueI18n({
  locale,
  fallbackLocale: locale,
  formatFallbackMessages: true,
  messages: {},
})

export default i18n
